import { SvgIconNames } from '@toggle/design-system';

export const getCatalystInsightIconProps = ({
  isBordered,
  isDisabled,
}: {
  isBordered: boolean;
  isDisabled?: boolean;
}) => {
  return {
    iconName: (isBordered ? 'Puzzle' : 'PuzzleBorderless') as SvgIconNames,
    viewBox: isBordered ? '0 0 34 40' : '0 0 12 12',
    fillColor: isDisabled ? 'var(--icon-soft)' : 'var(--chart-gold)',
  };
};
